import React, { useEffect, useState, useRef, useCallback } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Col, Image, Input, message, Row } from "antd";
import { useHistory } from "react-router-dom";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { useDispatch } from "react-redux";
import * as EBikeService from "../../service/EBikeService";
import { setCookie } from "../../service/HttpService";
import cookies from "react-cookies";
import { handleResponse } from "../projects/common/action/handleResponse";
import picture1 from "../../style/img/login-mobile.png";
import picture2 from "../../style/img/login-computer.png";
import SmartEnergyService from "../projects/smart_energy/service";
import Captcha from "react-captcha-code";
import "../../style/login.scss";
import "../../style/logincss/yggn.css"
const Login = (props) => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [picture, setPicture] = useState(picture1);
  //验证码
  const [btnBool, setBtnBool] = useState(false);
  const [btnText, setBtnText] = useState("发送验证码");
  const [phone, setPhone] = useState("");
  const [smsCode, setSmsCode] = useState("");
  const [yzmCode, setYzmCode] = useState("");
  const [code, setCode] = useState("");
  const [btn, setBtn] = useState({
    isLoading: false,
    name: "登录",
  });
  const dispatch = useDispatch();
  const [realname, setRealname] = useState(document.getElementById("realname").value);
  const captchaRef = useRef();
  const loginTypeLogo = {
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
    width: "60px",
    height: "60px",
  };

  useEffect(() => {
    let link = window.location.href;
    if(link.indexOf('zl.hossnow.cn') >= 0){
      setRealname("zl");
    }else if(link.indexOf('zjk.hossnow.cn') >= 0){
      setRealname("zjk");
    }else if(link.indexOf('iesmsweb.ebike-charge.com')>=0){
      setRealname("yunrui");
    }else if(link.indexOf('xgczhyd.ebike-charge.com')>=0){
      setRealname("xgc");
    }else if(link.indexOf('www.yggn365.com.cn')>=0){
      console.log(link);
      setRealname("yggn");
    }else{
      setRealname("yunrui");
    }
  }, [realname]);

  const validatePhone = () => {
    if (!phone) {
      message.error("请输入手机号码！");
      return false;
    }
    if (!RegExp(/^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(17[013678])|(18[0,5-9]))\d{8}$/).test(phone)) {
      message.error("请输入正确的手机号码！");
      return false;
    }
    return true;
  };
  const validateSmsCode = () => {
    if (!smsCode) {
      message.error("请输入验证码！");
      return false;
    }
    if (!RegExp(/^[0-9]{4}$/).test(smsCode)) {
      message.error("请输入正确的验证码！");
      return false;
    }
    return true;
  };
  const handleLogin1 = () => {
    if (!validatePhone() || !validateSmsCode()) {
      return;
    }
    message.error("该手机号码未注册");
  };
  //发送验证码
  let maxTime = 60;
  const sendCode = () => {
    if (!validatePhone()) {
      return;
    }
    SmartEnergyService.RemoteContro.sendSmsCodeWithoutToken({
      corpUserMobile: phone,
    })
      .then((json) => {
        if (json.code === 0) {
          message.success("发送成功");
          setBtnText(`重新获取${maxTime}`);
          setBtnBool(true);
          const timer = setInterval(() => {
            if (maxTime > 0) {
              --maxTime;
              setBtnText(`重新获取${maxTime}`);
            } else {
              setBtnText("重新获取");
              setBtnBool(false);
              clearInterval(timer);
            }
          }, 1000);
        }
        if (json.code === 1) {
          message.error("发送失败");
        }
      })
      .catch((e) => {
        console.error("发送失败:" + e);
        message.error("发送失败");
      });
  };

  //切换图标
  const handleSwitchIcon = (e) => {
    let flag = !e;
    flag ? setPicture(picture1) : setPicture(picture2);
  };
  const randomNum = (m, n) => {
    return Math.floor(Math.random() * (n - m + 1) + m);
  };
  const handleLogin = () => {
    if (username.trim() == "") {
      message.error("用户名不能为空");
    } else if (password.trim() == "") {
      message.error("密码不能为空");
    } else if (yzmCode !== code) {
      message.error("验证码错误");
      setYzmCode("");
      captchaRef.current.refresh();
    } else {
      NProgress.start();
      setBtn({
        isLoading: true,
        name: "登录中",
      });
      EBikeService.login(username, password)
        .then((json) => {
          if (json.access_token) {
            let newJson = {
              ...json,
              usernames: username,
            };
            setCookie(cookies, newJson);
            handleResponse(
              EBikeService.getUserInfo(),
              (jsonData) => {
                // jsonData
                let logParams = {
                  ...jsonData,
                  loginType: "web",
                };
                EBikeService.addLoginLog(logParams);
              },
              "获取用户信息失败"
            );
            if (history.location.pathname === "/login" || history.location.pathname === "/") {
              history.push("/app");
            } else {
              history.push(history.location.pathname);
            }
          } else {
            message.error("用户名或密码错误");
            setBtn({
              isLoading: false,
              name: "登录",
            });
          }
        })
        .catch((err) => {
          setBtn({
            isLoading: false,
            name: "登录",
          });
          if (err.response) {
            if (err.response.status == 401 || err.response.status == 400) {
              message.error("用户名或密码错误");
            } else if (err.response.status == 406) {
              message.error("账号已锁定，请5分钟后再试");
            } else {
              console.error("登录请求发生异常:" + err);
              message.error("请求发生了异常,请联系管理员");
            }
          } else {
            console.error(err);
            message.error("网络连接失败");
          }
        });
      NProgress.done();
    }
  };
  const handleClick = (e) => {
    console.log(e);
    setYzmCode(e.target.value);
  };
  const handCaptcha = (captcha) => {
    console.log("captcha:", captcha);
    setCode(captcha);
  };

  return (
    <Row style={{ width: "100%", height: "100%" }}>
      <Col span={14}>
        <div className="new_login_bg"></div>
      </Col>
      <Col span={10}>
        <div className="xjf-login-form">
          <div className="xjf-login-title">综合能源服务</div>
          <p>用户名</p>
          <Input
            placeholder="用户名"
            onChange={(e) => setUsername(e.target.value)}
            style={{ marginBottom: "1.5rem" }}
            size="large"
            prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          />
          <p>登录密码</p>
          <Input.Password
            placeholder="密码"
            onChange={(e) => setPassword(e.target.value)}
            onPressEnter={handleLogin}
            style={{ marginBottom: "1.5rem" }}
            size="large"
            prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          />
           {cookies.load("userList") === undefined ? (
            <Row align="middle" style={{ marginBottom: "20px" }}>
              <Col span={16}>
                <Input onChange={handleClick} charNum={4} value={yzmCode} />
              </Col>
              <Col span={8} style={{ textAlign: "right" }}>
                <Captcha charNum={4} onChange={handCaptcha} ref={captchaRef} bgColor="#fff" height="25" />
              </Col>
            </Row>
          ) : (
            ""
          )}
          <Button
            type="primary"
            onClick={handleLogin}
            loading={btn.isLoading}
            block={true}
            style={{ height: "40px", marginTop: "1.5rem" }}
            className="login-btn"
          >
            {btn.name}
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default Login;
